import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  changeMobileSidebarVisibility,
  changeSidebarVisibility,
} from 'redux/actions/sidebarActions';
import { addCookies } from 'redux/actions/layoutActions';

import Footer from 'shared/components/layout/Footer';
import ConfigCookie from 'shared/components/layout/ConfigCookie';
import { SidebarProps } from 'shared/prop-types/ReducerProps';

import Topbar from './topbar/Topbar';

const Layout = ({ dispatch, sidebar }) => {
  const theme = useSelector((state) => state.theme);
  const layout = useSelector((state) => state.layout);
  const { cookies } = layout;
  const layoutClass = classNames({
    layout: true,
    'layout--collapse': sidebar.collapse,
  });

  const sidebarVisibility = () => {
    dispatch(changeSidebarVisibility());
  };

  const mobileSidebarVisibility = () => {
    dispatch(changeMobileSidebarVisibility());
  };

  useEffect(() => {
    if (document.cookie) {
      dispatch(addCookies(document.cookie));
    } else {
      dispatch(addCookies(null));
    }
  }, []);

  const onAcceptCookies = () => {
    document.cookie = 'username=John Doe';
    dispatch(addCookies(document.cookie));
  };

  return (
    <div className={layoutClass}>
      <Topbar
        changeMobileSidebarVisibility={mobileSidebarVisibility}
        changeSidebarVisibility={sidebarVisibility}
        logoSrc={theme.logoHeader}
        backgroundColor={theme.backgroundHeader}
        iconColor={theme.headerIconColor}
        textColor={theme.headerTextColor}
      />
      {!cookies ? (
        <ConfigCookie onClick={() => onAcceptCookies()} />
      ) : (
        <Footer
          logoSrc={theme.logoFooter}
          backgroundColor={theme.backgroundFooter}
          footerText={theme.footerText}
          iconColor={theme.footerIconColor}
          textColor={theme.footerTextColor}
          facebookLink={theme.facebookLink}
          linkedinLink={theme.linkedinLink}
          youtubeLink={theme.youtubeLink}
          twitterLink={theme.twitterLink}
          phone={theme.phone}
          showLogoFooter={theme.showLogoFooter}
        />
      )}
    </div>
  );
};

Layout.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sidebar: SidebarProps.isRequired,
};

export default withRouter(
  connect((state) => ({
    sidebar: state.sidebar,
  }))(Layout)
);
